import React from 'react';
import { CrudType, getCrud } from '@awp/shared/Crud';

export interface EntityProps {
  entity: any;
  [key: string]: any;
}

export interface CrudEntity {
  entityName: string;
  entityPluralName?: string;
  mode: string;
}

export abstract class CrudService {
  public crud: CrudType | null = null;

  protected constructor(crudEntity?: CrudEntity) {
    if (crudEntity) {
      this.crud = getCrud(crudEntity.entityName, crudEntity.mode, crudEntity.entityPluralName);
    }
  }

  /**
   * Gets the columns for a table.
   * @param props - The props containing the entity data.
   * @returns The columns for the table.
   */
  abstract getColumns(props: any): any;

  /**
   * Gets the action menu for a table column.
   * @param event - The event object.
   * @returns The action menu for the form.
   */
  abstract getActionMenu(event: any): React.ReactElement;

  /**
   * Gets the fields for the form.
   * @param props - The props containing the form values.
   * @returns The fields for the form.
   */
  abstract getFields(props: any): React.ReactElement;

  /**
   * Gets the validations for the form.
   * @param props - The props containing the form values.
   * @returns The validations for the form.
   */
  abstract getValidations(props?: any): any;

  /**
   * Maps the initial values for the form.
   * @param props - The props containing the entity data.
   * @returns The mapped initial values.
   */
  abstract mapInitialValues(props: EntityProps): any;

  /**
   * Maps the form values to a Data Transfer Object (DTO).
   * @param props - The props containing the form values.
   * @returns The mapped DTO.
   */
  abstract mapFormToDTO(props: EntityProps): any;

  /**
   * Cleans the form values
   * @param props - The props containing the form values.
   * @returns The cleaned form values.
   */
  abstract cleanFormValues(props: EntityProps): any;
}
